import { useTranslation } from 'react-i18next';
import SEOSettingsCms from 'views/SEO/SEOSettingsCms';

import { DialogLoader } from '../../../components/DialogLoader';
import { usePanelConfigurationContext } from './PanelConfiguration.context';
import FormControlButtons from '../../../components/FormControlButtons/FormControlButtons';
import CustomMenuOptions from './CustomMenuOptions';
import ClientPanelGeneralSettings from './ClientPanelGeneralSettings';
import DishDetails from './DishDetails';
import RefLinksSettings from './RefLinksSettings';
import DishImageConfig from './DishImageConfig';

const PanelConfigurationView = () => {
  const { t } = useTranslation();
  const { module, isLoading, handleSubmit, setModule } =
    usePanelConfigurationContext();

  return (
    <>
      <DialogLoader
        loaderState={isLoading}
        text={t('common.shared.isLoading')}
      />
      {!isLoading && (
        <>
          <ClientPanelGeneralSettings />
          <CustomMenuOptions />
          <DishDetails />
          <DishImageConfig />
          <RefLinksSettings />
          {module.configuration.SeoCmsClientPanelLogin && (
            <SEOSettingsCms
              state={module}
              setState={setModule}
              section="SeoCmsClientPanelLogin"
            />
          )}
          {module.configuration.SeoCmsClientPanelRegister && (
            <SEOSettingsCms
              state={module}
              setState={setModule}
              section="SeoCmsClientPanelRegister"
            />
          )}
          {module.configuration.SeoCmsClientPanelMyAccount && (
            <SEOSettingsCms
              state={module}
              setState={setModule}
              section="SeoCmsClientPanelMyAccount"
            />
          )}
          <FormControlButtons
            submitText={t('common.shared.save')}
            handleSubmit={handleSubmit}
          />
        </>
      )}
    </>
  );
};

export default PanelConfigurationView;
